import Vue from 'vue'
import Router from 'vue-router'
import Login from "../views/Login";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name:'index',
            component: () => import("../views/Index"),
            children: [
                {
                    path: '/Me',
                    name: 'Me',
                    component: () => import('../views/user/Me'),
                }
            ]
        },
        {
            path: '/WordBook',
            name:'WordBook',
            component: () => import("../views/wordbook/WordBook")
        },
        {
            path: '/Retrieve',
            name: 'Retrieve',
            component: () => import("../views/Retrieve")
        },
        // {
        //     path: '/Test',
        //     name: 'Test',
        //     component: () => import("../views/Test")
        // },
        {
            path: '/ChoiceWordBook',
            name: 'ChoiceWordBook',
            component: () => import('../views/wordbook/ChoiceWordBook')
        },

        {
            path: '/NotReally',
            name: 'NotReally',
            component: () => import('../views/wordbook/NotReally')
        },
        {
            path: '/ArticleNothing',
            name: 'ArticleNothing',
            component: () => import('../views/article/ArticleNothing')
        },
        {
            path: '/ArticleHavePlan',
            name: 'ArticleHavePlan',
            component: () => import('../views/article/ArticleHavePlan')
        },
        {
            path: '/ChoiceArticles',
            name: 'ChoiceArticles',
            component: () => import('../views/article/ChoiceArticles')
        },
        {
            path: '/ArticleList',
            name: 'ArticleList',
            component: () => import('../views/article/ArticleList')
        },

        {
            path: '/ModuleList',
            name: 'ModuleList',
            component: () => import('../views/article/ModuleList')
        },
        {
            path: '/ArticleLearn',
            name: 'ArticleLearn',
            component: () => import('../views/article/ArticleLearn')
        },
        {
            path: '/SentenceLearn',
            name: 'SentenceLearn',
            component: () => import('../views/article/SentenceLearn')
        },
        {
            path: '/StrangeWord',
            name: 'StrangeWord',
            component: () => import('../views/user/StrangeWord'),
        },
        {
            path: '/BookPlan',
            name: 'BookPlan',
            component: () => import('../views/wordbook/BookPlan')
        },
        {
            path: '/BookModuleList',
            name: 'BookModuleList',
            component: () => import('../views/wordbook/BookModuleList')
        },
        {
            path: '/WordStudy',
            name: 'WordStudy',
            component: () => import('../views/wordbook/word/WordStudy')
        },
        {
            path: '/Interpretation',
            name: 'Interpretation',
            component: () => import('../views/wordbook/word/Interpretation')
        },
        {
            path: '/StartExam',
            name: 'StartExam',
            component: () => import('../views/wordbook/StartExam')
        },
        {
            path: '/ExamAnalysis',
            name: 'ExamAnalysis',
            component: () => import('../views/wordbook/ExamAnalysis')
        },
        {
            path: '/ExamQuestion',
            name: 'ExamQuestion',
            component: () => import('../views/wordbook/ExamQuestion')
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        // {path: "*", redirect: {name: "book"}}, // 重定向到主页
        {
            path: '/Exam',
            name: 'Exam',
            component: () => import('../views/wordbook/Exam')
        },
        {
            path: '/DailyPlan',
            name: 'DailyPlan',
            component: () => import('../views/wordbook/DailyPlan'),
        },
        {
            path: '/ExportWord',
            name: 'ExportWord',
            component: () => import('../views/wordbook/ExportWord'),
        },
        {
            path: '/StudyWord',
            name: 'StudyWord',
            component: () => import('../views/wordbook/StudyWord'),
        },
        {
            path: '/TestWord',
            name: 'TestWord',
            component: () => import('../views/wordbook/TestWord'),
        },
        {
            path: '/WrongLog',
            name: 'WrongLog',
            component: () => import('../views/wordbook/WrongLog'),
        },
        {
            path: '/TestRecord',
            name: 'TestRecord',
            component: () => import('../views/wordbook/TestRecord'),
        },
        {
            path: '/NewWord',
            name: 'NewWord',
            component: () => import('../views/wordbook/NewWord'),
        },
        {
            path: '/AllExam',
            name: 'AllExam',
            component: () => import('../views/wordbook/AllExam'),
        },
        {
            path: '/SampleExam',
            name: 'SampleExam',
            component: () => import('../views/wordbook/SampleExam'),
        },
    ]
})
const VueRouterPush = Router.prototype.push

Router.prototype.push = function push(to) {

    return VueRouterPush.call(this, to).catch(err => err)

}



// WEBPACK FOOTER //
// ./src/router/index.js